import { render } from "./PermissionMatrix.vue?vue&type=template&id=cc0a7802&scoped=true"
import script from "./PermissionMatrix.vue?vue&type=script&lang=js"
export * from "./PermissionMatrix.vue?vue&type=script&lang=js"

import "./PermissionMatrix.vue?vue&type=style&index=0&id=cc0a7802&scoped=true&lang=css"

import exportComponent from "C:\\actions-runner\\_work\\cims-billing.ui\\cims-billing.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc0a7802"]])

export default __exports__